<script setup lang="ts">
import { cn } from 'pejer/src/lib/utils';

const props = defineProps<{
  class?: any
}>()
</script>
<template>
  <div :class="cn('flex items-center w-full', props.class)">
    <hr class="border-b-2 border-gray-200 flex-1 rounded-l-full" />
    <span class="text-gray-500 text-xs px-2">
      <slot />
    </span>
    <hr class="border-b-2 border-gray-200 flex-1 rounded-r-full" />
  </div>
</template>
